// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, xScreen } from "@awc/XDL/Utilities";
import { autocompleteBrandsStyles } from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import { css } from "styled-components";

autocompleteBrandsStyles.link = {
    typographyProps: {
        ellipsis: true,
        css: css`
            &&& {
                width: 100%;
                text-align: left;
                margin: 5px 0;
                color: ${color("common.ui14")};
                &:hover {
                    color: ${color("common.ui8")};
                }
            }
        `,
    },
    css: css`
        width: auto;
        overflow: hidden;
    `,
};

autocompleteBrandsStyles.autocompleteBrandsColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 300px;
        ${xScreen("lte", "md")} {
            width: 394px;
        }
    `,
};
